import React, { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, Button } from "../../../components/ui";

export default function AddPurchaserModal({ isOpen, onClose, onSave, loading, initialData }) {
    const isEditing = Boolean(initialData);
    const [formData, setFormData] = useState({
        purchaser_name: "",
        purchaser_contact: "",
        purchaser_email: ""
    });

    useEffect(() => {
        if (!isOpen) return;
        setFormData({
            purchaser_name: initialData?.purchaser_name || "",
            purchaser_contact: initialData?.purchaser_contact || "",
            purchaser_email: initialData?.purchaser_email || ""
        });
    }, [isOpen, initialData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave(formData);
    };

    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className="sm:max-w-[425px]">
                <DialogHeader>
                    <DialogTitle>{isEditing ? "Edit Property Purchaser" : "Add Property Purchaser"}</DialogTitle>
                </DialogHeader>
                <form onSubmit={handleSubmit} className="grid gap-4 py-4">
                    <div className="grid grid-cols-4 items-center gap-4">
                        <label htmlFor="purchaser_name" className="text-right text-xs font-bold text-[#374151]">
                            Name
                        </label>
                        <input
                            id="purchaser_name"
                            name="purchaser_name"
                            value={formData.purchaser_name}
                            onChange={handleChange}
                            placeholder="Full Name"
                            className="col-span-3 h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
                            required
                        />
                    </div>
                    <div className="grid grid-cols-4 items-center gap-4">
                        <label htmlFor="purchaser_email" className="text-right text-xs font-bold text-[#374151]">
                            Email
                        </label>
                        <input
                            id="purchaser_email"
                            name="purchaser_email"
                            type="email"
                            value={formData.purchaser_email}
                            onChange={handleChange}
                            placeholder="Email Address"
                            className="col-span-3 h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
                        />
                    </div>
                    <div className="grid grid-cols-4 items-center gap-4">
                        <label htmlFor="purchaser_contact" className="text-right text-xs font-bold text-[#374151]">
                            Phone
                        </label>
                        <input
                            id="purchaser_contact"
                            name="purchaser_contact"
                            value={formData.purchaser_contact}
                            onChange={handleChange}
                            placeholder="Phone Number"
                            className="col-span-3 h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
                        />
                    </div>
                    <DialogFooter>
                        <Button type="button" variant="outline" onClick={onClose} disabled={loading}>
                            Cancel
                        </Button>
                        <Button type="submit" className="bg-[#55C5D0] hover:bg-[#4AADB7] text-white" disabled={loading}>
                            {loading ? "Saving..." : (isEditing ? "Update Purchaser" : "Save Purchaser")}
                        </Button>
                    </DialogFooter>
                </form>
            </DialogContent>
        </Dialog>
    );
}
